function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React from 'react';
import { safeSelect, PromiseCache } from '@sie/web-common-utils';
import formatStaticUrl from '../utils/formatStaticUrl';
var svgPalletteId = 'psw-svg-pallette';
/**
 * @typedef {Object} SvgLoaderConfigBrowser
 * @property {string} o.config.namespace identifies the type of inline svg use case (hero text,
 *  icon, graphic)
 * @property {string} o.config.url where to load the svg symbol src from (this is likely static.
 *  playstation.com) this can be a template which will use the npEnvironment and version config
 *  values (e.g. 'https://my.{envExceptNp}.domain.com/{version}/')
 * @property {string} [o.config.npEnvironment] which line to use (e.g. 'e1-np' or 'np')
 * @property {string} [o.config.version] the version of web-common icons deployed to static to use
 * @property {boolean} o.config.isSsr whether we're SSRing
 */

/**
 * Whether the icon pallette already exists
 * @return {Node} dom element containing all icon symbols as children
 */

var getSvgPallette = function getSvgPallette() {
  return document.getElementById(svgPalletteId);
};
/**
 * Query and prep all SSR'd icons to be moved to the icon pallette
 */


var collectAllSsrIcons = function collectAllSsrIcons() {
  var seenIcons = {};

  _toConsumableArray(document.querySelectorAll('[data-original-icon-id]')).forEach(function (el) {
    var iconId = el.dataset.originalIconId;
    var icon = el.firstChild;
    var iconSymbolEl = el.querySelector('symbol');

    if (!seenIcons[iconId] && iconSymbolEl) {
      iconSymbolEl.setAttribute('id', iconId);
      seenIcons[iconId] = icon;
    }

    var parentElement = el.parentElement.querySelector('use');

    if (parentElement) {
      parentElement.setAttribute('href', "#".concat(iconId));
    }
  });

  return seenIcons;
};
/**
 * Create the icon pallette to store icons as they are loaded
 * @return {Node} dom element containing all icon symbols as children
 */


var createSvgPallette = function createSvgPallette() {
  var iconPallette = getSvgPallette();
  if (iconPallette) return iconPallette;
  var ssrIcons = collectAllSsrIcons();
  var fragment = document.createDocumentFragment();
  var palletteEl = document.createElement('div');
  palletteEl.id = svgPalletteId; // Inline style so the pallette is never shown even when stylesheets fail to load

  palletteEl.style = "\n    position: relative;\n    display: block;\n    line-height: 0;\n    opacity: 0;\n    width: 0;\n    height: 0;\n    overflow: hidden;\n  ".trim();
  palletteEl.setAttribute('aria-hidden', true);
  Object.keys(ssrIcons).forEach(function (id) {
    return palletteEl.appendChild(ssrIcons[id]);
  });
  fragment.appendChild(palletteEl);
  return document.body.insertBefore(fragment, document.body.childNodes[0]);
};
/**
 * Whether the svg of a given namespace and type already exists in the svg pallette
 * @param {Object} o
 * @param {string} o.namespace the namespace of the svg to check for
 * @param {string} o.type the type of svg to check for
 * @returns {boolean}
 */


var isSvgInPallette = function isSvgInPallette(_ref) {
  var namespace = _ref.namespace,
      type = _ref.type;
  return !!document.getElementById("".concat(namespace, ":").concat(type));
};
/**
 * Add the svg symbol source (text) to the icon pallette
 * @param {string} src the svg symbol source
 */


var addSvgToPallette = function addSvgToPallette(src) {
  if (!src) return false;
  var iconPallette = getSvgPallette();
  var svgIconFragment = document.createRange().createContextualFragment(src);
  return iconPallette.appendChild(svgIconFragment);
};
/**
 * Fetch the svg symbol source from the provided location in Icon.configure
 * @param {string} type the type (fileName) of svg to load
 * @param {SvgLoaderConfigBrowser} config the icon configuration
 */


var fetchSvg = function fetchSvg(type, _ref2) {
  var namespace = _ref2.namespace,
      url = _ref2.url,
      npEnvironment = _ref2.npEnvironment,
      version = _ref2.version,
      isSsr = _ref2.isSsr;
  if (isSsr || isSvgInPallette({
    namespace: namespace,
    type: type
  })) return Promise.resolve();
  var svgUrl = formatStaticUrl({
    url: url,
    npEnvironment: npEnvironment,
    version: version
  });
  return fetch("".concat(svgUrl).concat(type, ".svg")).then(function (r) {
    return r.text();
  }).then(function (s) {
    addSvgToPallette(s);
    var el = document.getElementById("".concat(namespace, ":").concat(type));

    try {
      el.parentElement.dataset.name = "".concat(namespace, ":").concat(type);
    } catch (e) {
      console.info('could not set data-name on svg', e);
    }

    return el;
  }).catch(function (e) {
    console.warn("Failed to load svg ".concat(namespace, ":").concat(type, " from ").concat(svgUrl), e);
  });
};

var stringifyViewBox = function stringifyViewBox(svgRect) {
  if (!svgRect) return null;
  var x = svgRect.x,
      y = svgRect.y,
      width = svgRect.width,
      height = svgRect.height;
  return "".concat(x, " ").concat(y, " ").concat(width, " ").concat(height);
};
/**
 * Client side rendered implementation of StylableSvg.load, which attempts to hydrate any
 * server side rendered inline svg which used loadSvgSsr.
 *
 * @param {string} type
 * @param {Object} o
 * @param {string} [o.label] the title for the icon
 * @param {SvgLoaderConfigBrowser} config the icon configuration
 * @returns {ReactNode}
 */


export default function loadSvg(type) {
  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref3$namespace = _ref3.namespace,
      namespace = _ref3$namespace === void 0 ? 'ps-icon' : _ref3$namespace,
      label = _ref3.label,
      config = _ref3.config,
      viewBox = _ref3.viewBox,
      _ref3$onLoad = _ref3.onLoad,
      onLoad = _ref3$onLoad === void 0 ? function () {} : _ref3$onLoad;

  var svgProps = {
    viewBox: viewBox
  };

  if (label) {
    svgProps = _objectSpread(_objectSpread({}, svgProps), {}, {
      role: 'img'
    });
  } else {
    /**
     * Per SVG specs, SVG focusable attribute accepts values 'true',
     * 'false', or 'auto'. As such React expects this to be passed
     * as string. Using a boolean value will cause in the attribute
     * not being used for the SVG. Full discussion can be seen at
     * https://github.com/facebook/react/issues/12481
     */
    svgProps = _objectSpread(_objectSpread({}, svgProps), {}, {
      'aria-hidden': true,
      focusable: 'false'
    });
  }

  var icon = /*#__PURE__*/React.createElement("svg", svgProps, /*#__PURE__*/React.createElement("title", null, label), /*#__PURE__*/React.createElement("use", {
    href: "#".concat(namespace, ":").concat(type)
  }));
  if (config.isSsr) return icon;

  if (!loadSvg.svgs) {
    createSvgPallette();

    loadSvg.reset = function () {
      loadSvg.svgs.clear();
      getSvgPallette().innerHTML = '';
    };

    loadSvg.svgs = new PromiseCache({
      shouldKeepResult: true
    });
  }

  loadSvg.svgs.cache("".concat(namespace, ":").concat(type), function () {
    return fetchSvg(type, _objectSpread(_objectSpread({}, config), {}, {
      namespace: namespace
    }));
  }).then(function (el) {
    if (typeof onLoad !== 'function') return;
    onLoad({
      el: el,
      viewBox: stringifyViewBox(safeSelect(el, 'viewBox.baseVal'))
    });
  });
  return icon;
}